module.exports = __webpack_public_path__ + "img/HIGHSQ.60915c17.png";